import React from "react";
import '../styles/Nav.css';

import my_cv from '../../utils/Sourabh_CV.pdf';

class Nav extends React.Component{

    navSlide(){
        const nav = document.querySelector('.nav-links');
        const navLinks = document.querySelectorAll('.nav-links li');
        const burger = document.querySelector('.burger');

        nav.classList.toggle('nav-active');

        navLinks.forEach((link, index)=> {
            link.style.animation = `navLinkFades 0.5s ease`;
        })

        burger.classList.toggle('toggle');

    }

    onLinkClick = () =>{
        const nav = document.querySelector('.nav-links');
        nav.classList.toggle('nav-active');
    }
    render(){
        const {name} = this.props;
        return(
            <nav>
                <div className="logo grow">
                    <h4> <a  href="/" title="Home"> {'<'}{name}{'/>'} </a></h4>
                </div>
                <ul className="nav-links">
                    <li className="grow">
                        <a href="#aboutpage" title="About" onClick={this.onLinkClick}> About</a>
                    </li>
                    <li className="grow">
                        <a href="#experiencepage" title="Experience" onClick={this.onLinkClick}> Experience</a>
                    </li>
                    <li className="grow">
                        <a href="#projectspage" title="Projects" onClick={this.onLinkClick}> Projects</a>
                    </li>
                    <li className="grow">
                        <a href="#skillspage" title="Skills" onClick={this.onLinkClick}> Skills</a>
                    </li>
                    <li className="grow">
                        <a href="#contactpage" title="ContactMe" onClick={this.onLinkClick}> Contact Me</a>
                    </li>
                    <li className="grow">
                        <a href={my_cv} download={'Sourabh_CV'} title="Resume" onClick={this.onLinkClick}> Resume</a>
                    </li>
                </ul>
                <div className="burger" onClick={this.navSlide}>
                    <div className="line1"></div>
                    <div className="line2"></div>
                    <div className="line3"></div>
                </div>
            </nav>

            // this.getNav()
        );
    }
}

export default Nav;